var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 9c0 2.796 0 4.194-.457 5.296a6 6 0 0 1-3.247 3.247C13.194 18 11.796 18 9 18c-2.796 0-4.193 0-5.296-.457a6 6 0 0 1-3.247-3.247C0 13.194 0 11.796 0 9c0-2.796 0-4.193.457-5.296A6 6 0 0 1 3.704.457C4.807 0 6.204 0 9 0c2.796 0 4.194 0 5.296.457a6 6 0 0 1 3.247 3.247C18 4.807 18 6.204 18 9ZM9.323 6.644a428.51 428.51 0 0 0-5.25 2.261c-.425.17-.648.335-.669.497-.034.274.31.382.776.529l.197.062c.46.15 1.078.325 1.399.332.291.006.617-.114.976-.361 2.451-1.655 3.717-2.491 3.796-2.51.056-.012.134-.028.187.019.052.047.047.135.042.159-.034.145-1.38 1.397-2.078 2.044-.217.202-.37.345-.402.378-.071.073-.143.143-.212.21-.427.411-.747.72.018 1.224.367.242.661.442.955.642.32.218.64.436 1.053.707.106.069.206.14.304.21.373.266.708.505 1.122.467.24-.022.489-.248.615-.923.298-1.594.884-5.047 1.02-6.47a1.584 1.584 0 0 0-.015-.355.379.379 0 0 0-.128-.243.592.592 0 0 0-.35-.105c-.338.006-.857.187-3.356 1.226Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h18v18H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.049947add151554f6a5b334d666afef0.svg";
export { ForwardRef as ReactComponent };